import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=14b279c8&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=14b279c8&prod&scoped=true&lang=scss"
import style1 from "./UserAvatar.vue?vue&type=style&index=1&id=14b279c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b279c8",
  null
  
)

export default component.exports